import { useQueryClient, useMutation } from "@tanstack/react-query";
import ArtistService from "../service/ArtistService";
import { useNotification } from "../context/NotificationContext";

export function useDeleteArtist() {
  const queryClient = useQueryClient();
  const { addNotification } = useNotification();

  const { mutate: deleteArtist, isLoading: isDeleting } = useMutation({
    mutationFn: (idArtist) => ArtistService.delete(idArtist),

    onSuccess: () => {
      queryClient.invalidateQueries(["artists"]);
      addNotification("Artist Deleted", "success");
    },
    onError: (error) => {
      // Gestisci l'errore
      addNotification(error.message, "error");
      console.error("Error deleting artist:", error);
    },
  });

  return { deleteArtist, isDeleting };
}

/* const updateWorkData = await WorkService.update(data, id);
updateWork(updateWorkData);



function updateWork(updatedWorkData) {
    const index = data.findIndex(
      (artwork) => artwork.id === updatedWorkData.id
    );
    // Crea una copia dei dati correnti
    const newData = [...data];
    // Aggiorna l'opera d'arte nei dati
    newData[index] = updatedWorkData;
    // Aggiorna lo stato dei dati
    //setData(newData);
    localStorage.removeItem(`searchData`);
    localStorage.setItem(`searchData`, JSON.stringify(newData));


 */
